export default __webpack_public_path__ + "static/media/CubeIcon.356464fd.svg";